import React, { useContext, useEffect, useState } from "react";
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import useAlert from "~/common/hooks/useAlert";

// Pages
import Edit from "~/pages/round/RoundReg/Edit";
import Inquiry from "~/pages/round/RoundReg/Inquiry";
import Question from "~/pages/round/RoundReg/Question";
import { Case, If } from "~/common/components/If";
import { AppContext } from "../RoundRegContext";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const RoundRegContainer = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const roundRegRequest = useRequest("post", "/vc/round/add");
	const roundEditRequest = useRequest("post", "/vc/round/edit");
	const [step, setStep] = useState("edit");
	const [showWarningAlert, Warning] = useAlert();
	const [showRegisterAlert, RegisterValidation] = useAlert();
	const [showEditAlert, EditValidation] = useAlert();
	const [showRegSuccess, RegSuccess] = useAlert();
	const [showEditSuccess, EditSuccess] = useAlert();
	const [warningMsg, setWarningMsg] = useState("");
	const [questionPreModal, setQuestionPreModal] = useState(false);

	// 심사항목 > 내부&외부
	const [reviewSettingData, setReviewSettingData] = useState({
		external: false,
		noticeTitle: "",
		noticeContent:"",
		noticeCheck: false,
		reviewSettingIdx: null,
		judgeList: [
			// {
			// 	userIdx: 144,
			// 	role: "심사참여",
			// 	img: "https://vc-cdn.dev.gitbal.io/user/profile/2024-07-24-04:42:39-스크린샷 2024-06-14 오후 5.44.38.png",
			// 	external: false,   // 외부심사역인지 아닌지
			// 	email: "ryu1s@boomco.org",
			// 	name: "메롱",
			// 	id: "",
			// 	pw: ""
			// }
		]
	});
	// 공지사항
	const [notiCheck, setNotiCheck] = useState(false);

	const {
		roundRegForm,
		list,
		qList,
		detailContent,
		mainImg,
		externalLink,
		check,
		registerWay,
		targetModifyIdx,
		roundStatus,
		fileList,
		snsValueList,
	} = useContext(AppContext);

	const pattern = new RegExp(
		"^(https?:\\/\\/)?" + // 프로토콜
			"((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // 도메인 이름
			"((\\d{1,3}\\.){3}\\d{1,3}))" + // 또는 IP (v4) 주소
			"(\\:\\d+)?(\\/[-a-z\\d%_.~+:@]*)*" + // 포트와 경로 (**@ 추가**)
			"(\\?[;&a-z\\d%_.~+=-]*)?" + // 쿼리 문자열
			"(\\#[-a-z\\d_]*)?$",
		"i"
	);

	const submit = (data) => {
		if (!detailContent) {
			setWarningMsg(t("pages.round.RoundReg.container.RoundRegContainer.contentRequired"));
			showWarningAlert();
		} else if (!mainImg) {
			setWarningMsg(t("pages.round.RoundReg.container.RoundRegContainer.imgRequired"));
			showWarningAlert();
		} else if (
			registerWay === "온라인 질의 작성하기" &&
			!externalLink &&
			list[0].title === ""
		) {
			setWarningMsg(t("pages.round.RoundReg.container.RoundRegContainer.questionRequired"));
			showWarningAlert();
		} else if (registerWay === "온라인" && !!pattern.test(externalLink) === false) {
			setWarningMsg(t("pages.round.RoundReg.container.RoundRegContainer.invalidLink"));
			showWarningAlert();
		} else if (registerWay === "오프라인" && !(data.address && data.addressDetail)) {
			setWarningMsg("주소를 입력해주세요.");
			showWarningAlert();
		} else if (
			snsValueList.some((item) => item.checked && !!pattern.test(item.text) === false)
		) {
			setWarningMsg(
				"SNS " + t("pages.round.RoundReg.container.RoundRegContainer.invalidLink")
			);
			showWarningAlert();
		} else {
			const snsText = (value) => {
				const snsItem = snsValueList.find((item) => item.value === value);
				return snsItem.checked ? snsItem.text : "";
			};

			let qListData = [...qList];
			if(qList?.length <= 1) {
				if(qListData[0].question === "" && qListData[0].answer === "") {
					qListData = [];
				} else {
					qListData = [{...qList[0], order: 0}]
				}
			} else {
				qListData = qList.map((item, idx) => (
					(item.hasOwnProperty("order")) ? item : ({...item, order: idx})
				));
			}

			// @INFO surveyList type CATEGORY 인 경우 required false 로 처리 한다.
			const surveyListData = list.map(item => (item.type === "CATEGORY") ? ({
				...item,
				required: false,
			}): item)

			const formData = {
				idx: targetModifyIdx,
				title: data.roundTitle,
				content: detailContent,
				description: data.introduction,
				img: mainImg,
				startDate: new Date(data.applyStartDate),
				endDate: new Date(data.applyEndDate),
				applyMethod: data.way || "온라인 질의 작성하기",
				survey: externalLink || "",
				place: data.way === "오프라인" ? "장소등록" : "온라인접수",
				managerName: data.hostName,
				managerEmail: data.hostEmail,
				zipCode: data.zipCode || "",
				address: data.address || "",
				addressDetail: data.addressDetail || "",
				contact: check,
				SurveyList: registerWay === "온라인 질의 작성하기" ? surveyListData : [],
				Qna: qListData,
				facebook: snsText("facebook"),
				twitter: snsText("twitter"),
				instagram: snsText("instagram"),
				linkedin: snsText("linkedin"),
				youtube: snsText("youtube"),
				startupCompanyIdxList: data.startupCompanyIdxList,
				uploadFiles: fileList,
				reviewSetting: { //  심사설정
					external: reviewSettingData?.judgeList?.filter(item => item.external)?.length > 0, // 외부심사역 1명이라도 있으면 true
					noticeTitle: (reviewSettingData.noticeCheck && reviewSettingData.noticeTitle) ? reviewSettingData.noticeTitle : "",
					noticeContent: (reviewSettingData.noticeCheck && reviewSettingData.noticeContent) ? reviewSettingData.noticeContent : "",
					reviewSettingIdx: data?.evaluateTemplate ?? null, // 심사항목 @INFO 삭제된 심사항목의 경우 null 로 넘긴다.
					judgeList: [  // 외부&내부 심사역
						...reviewSettingData?.judgeList
					]
				}
			};
			// 참여 심사역이 없는경우 alert
			const participateJudgeCheck = formData?.reviewSetting?.judgeList?.filter(judge => judge.role === "심사참여");
			if(participateJudgeCheck?.length <= 0 && !formData?.reviewSetting?.external) {
				setWarningMsg("내부 심사역(참여)을 선택해주세요.");
				showWarningAlert();
				return false;
			}
			
			// 등록
			if (roundStatus === "roundEdit") {
				showEditAlert().then(() => roundEditRequest.call(formData));
			} else {
				showRegisterAlert().then(() => roundRegRequest.call(formData));
			}
		}
	};


	useEffect(() => {
		switch (roundEditRequest.state) {
			case API_STATE.done:
				showEditSuccess().then(() => navigate("/round/management"));
				break;
			case API_STATE.error:
				console.error("err >", roundEditRequest.error.statusCode);
				switch (roundEditRequest.error.statusCode) {
					case 401:
						alert(
							t("pages.round.RoundReg.container.RoundRegContainer.roundEditOpenError")
						);
						navigate("/round/management");
						break;
					case 404:
						alert(
							t(
								"pages.round.RoundReg.container.RoundRegContainer.roundEditExistError"
							)
						);
						navigate("/round/management");
						break;
					case 500:
					default:
						alert(
							t(
								"pages.round.RoundReg.container.RoundRegContainer.roundEditServerError"
							)
						);
						navigate("/round/management");
						break;
				}
				break;
			default:
				break;
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [roundEditRequest.state, roundEditRequest.response, roundEditRequest.error]);

	useEffect(() => {
		switch (roundRegRequest.state) {
			case API_STATE.done:
				showRegSuccess().then(() => navigate("/round/management"));

				break;
			case API_STATE.error:
				console.error("err >", roundRegRequest.error);
				alert(t("pages.round.RoundReg.container.RoundRegContainer.roundRegError"));
				break;
			default:
				break;
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [roundRegRequest.state, roundRegRequest.response, roundRegRequest.error]);

	const headerButtons = [
		<button
			type="button"
			className="btn__solid"
			color="primary"
			onClick={roundRegForm.handleSubmit(submit)}
		>
			{roundStatus === "roundEdit"
				? t("pages.round.RoundReg.container.RoundRegContainer.edit")
				: t("pages.round.RoundReg.container.RoundRegContainer.save")}
		</button>,
		<button
			type="button"
			className="btn__solid"
			color="gray"
			onClick={() => navigate("/round/management")}
		>
			{t("pages.round.RoundReg.container.RoundRegContainer.cancel")}
		</button>,
	];

	const [showQuestionWarningAlert, QuestionWarning] = useAlert();
	const questionSubmit = () => {
		if (qList.some((item) => !item.question || !item.answer)) {
			showQuestionWarningAlert();
		} else {
			setStep("edit");
		}
	};

	const questionButtons = [
		<button
			type="button"
			className="btn__outline btn-preview"
			color="primary"
			onClick={() => setQuestionPreModal(true)}
		>
			{t("pages.round.RoundReg.container.Inquiry.btn-preview")}
		</button>,
		<button
			type="button"
			className="btn__solid btn-back"
			color="primary"
			onClick={questionSubmit}
		>
			{t("pages.round.RoundReg.container.Inquiry.btn-back")}
		</button>,
	];


	return (
		<>
			<NavbarAndSidebarLayout menu={["round", "register"]} type={"main"}>
				<PageHeader
					buttonList={
						step === "edit" ? headerButtons : step === "question" ? questionButtons : ""
					}
				/>
				<If condition={step} {...{ targetModifyIdx, setStep, reviewSettingData, setReviewSettingData }}>
					<Case condition="edit">
						<Edit />
					</Case>
					<Case condition="inquiry">
						<Inquiry />
					</Case>
					<Case condition="question">
						<Question {...{ questionPreModal, setQuestionPreModal, QuestionWarning }} />
					</Case>
				</If>
			</NavbarAndSidebarLayout>

			<Warning
				type="info"
				message={t("pages.round.RoundReg.container.RoundRegContainer.warning")}
				subMessage={warningMsg}
				confirm={t("pages.round.RoundReg.container.RoundRegContainer.confirm")}
			/>

			<RegSuccess
				type="success"
				message={t("pages.round.RoundReg.container.RoundRegContainer.regSuccess")}
				confirm={t("pages.round.RoundReg.container.RoundRegContainer.confirm")}
			/>

			<EditSuccess
				type="success"
				message={t("pages.round.RoundReg.container.RoundRegContainer.editSuccess")}
				confirm={t("pages.round.RoundReg.container.RoundRegContainer.confirm")}
			/>

			<RegisterValidation
				type="info"
				message={t("pages.round.RoundReg.container.RoundRegContainer.registerValidation")}
				// subMessage={t(
				// 	"pages.round.RoundReg.container.RoundRegContainer.registerValidation-sub"
				// )}
				reject={t("pages.round.RoundReg.container.RoundRegContainer.no")}
				confirm={t("pages.round.RoundReg.container.RoundRegContainer.yes")}
			/>

			<EditValidation
				type="info"
				message={t("pages.round.RoundReg.container.RoundRegContainer.editValidation")}
				reject={t("pages.round.RoundReg.container.RoundRegContainer.no")}
				confirm={t("pages.round.RoundReg.container.RoundRegContainer.yes")}
			/>
		</>
	);
};

export default RoundRegContainer;
